import { clearSignupData, clearTokens, clearUserData } from 'store/auth/auth.slice';
import { clearCausesData, clearSpecialCauseData, setSelectedCauses } from 'store/causes/causes.slice';
import { clearSelectedCharities } from 'store/charities/charities.slice';
import { clearQuotesStore } from 'store/creatorQuotes/creatorQuotes.slice';
import { useAppDispatch } from 'store/hooks';
import { clearNewFlowStore } from 'store/newFlow1/newFlow1.slice';

const useClearStores = () => {
   const dispatch = useAppDispatch();

   const clearOnLanding = () => {
      dispatch(clearCausesData());
      dispatch(clearNewFlowStore());
      dispatch(clearSignupData());
      dispatch(clearUserData());
      dispatch(clearTokens());
      dispatch(setSelectedCauses([]));
      dispatch(clearSpecialCauseData());
      dispatch(clearQuotesStore());
      dispatch(clearSelectedCharities());
   };

   return { clearOnLanding };
};

export default useClearStores;
